import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-item-business-grow-your-money.component.scss';
var FormItemBusinessGrowYourMoney = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessGrowYourMoney, _super);
    function FormItemBusinessGrowYourMoney(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessGrowYourMoney.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.businessType = this.element.querySelector(".js-business-type");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
            this.displayOtherContent = this.form.querySelector('.form-container__othercontent');
            this.displaybusinessType = this.form.querySelector('.form-container__businessType');
            this.displayIDNumber = this.form.querySelector('.form-container__Idnumber');
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
    };
    FormItemBusinessGrowYourMoney.prototype.bindEvents = function () {
        var _this = this;
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".js_business-reg");
        if (businessReg) {
            businessReg.addEventListener("input", function (event) {
                if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        //Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm("done"); });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm("close"); });
        }
        if (this.businessType) {
            this.businessType.addEventListener("change", function () { return _this.validateBusinessType("validate"); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        // this.dataSharingTeleSaleShowBtn.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // 	this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
        // 	this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
        // 	this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        // });
        // this.dataSharingTeleSaleHideBtn.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // 	this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
        // 	this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
        // 	this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        // });
        // this.dataSharingSmsShowBtn.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // 	this.dataSharingSmsTextArea.removeAttribute('hidden');
        // 	this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
        // 	this.dataSharingSmsHideBtn.removeAttribute('hidden');
        // });
        // this.dataSharingSmsHideBtn.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // 	this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
        // 	this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
        // 	this.dataSharingSmsShowBtn.removeAttribute('hidden');
        // });
        // this.dataSharingEmailShowBtn.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // 	this.dataSharingEmailTextArea.removeAttribute('hidden');
        // 	this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
        // 	this.dataSharingEmailHideBtn.removeAttribute('hidden');
        // });
        // this.dataSharingEmailHideBtn.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // 	this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
        // 	this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
        // 	this.dataSharingEmailShowBtn.removeAttribute('hidden');
        // });
    };
    FormItemBusinessGrowYourMoney.prototype.validateBusinessType = function (type) {
        var _this = this;
        // Business Reg Validations
        function dfcBusinessFormatBusinessReg(event) {
            var _stringLength = parseFloat(event.length);
            var _newLength = (_stringLength - 1);
            var _check = event.substring(_newLength);
            var reg = new RegExp('^[0-9]+$');
            if (reg.test(_check)) {
                if (event.length === 4) {
                    event = event += '/';
                }
                else if (event.length === 11) {
                    event = event += '/';
                }
                else if (event.length > 14) {
                    event = event.substring(0, 14);
                }
            }
            else {
                return event.substring(0, _newLength);
            }
            return event;
        }
        function dfcBusinessFormatExpression(inputText) {
            var _check = inputText.split('/');
            if (_check.length > 1) {
                var _valid1 = true;
                var _valid2 = true;
                var _valid3 = true;
                if (_check.length === 3) {
                    var _seg1 = new RegExp('^/d{4}$');
                    var _seg2 = new RegExp('^/d{6}$');
                    var _seg3 = new RegExp('^/d{2}$');
                    if (_seg1.test(_check[0])) {
                        _valid1 = false;
                    }
                    if (_seg2.test(_check[1])) {
                        _valid2 = false;
                    }
                    if (_seg3.test(_check[2])) {
                        _valid3 = false;
                    }
                    if (_valid1 && _valid2 && _valid3) {
                        return inputText;
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }
            }
            else if (inputText.length >= 12) {
                var _firstcharacters = inputText.substring(0, 4);
                var _secondCharacters = inputText.substring(5, 10);
                var _thirdCharacters = inputText.substring(11, 13);
                return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
            }
            return '';
        }
        function deleteContent(event) {
            if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                var reg = event.target.value;
                event.target.value = dfcBusinessFormatBusinessReg(reg);
            }
        }
        function addBlur(event) {
            var reg = event.target.value;
            event.target.value = dfcBusinessFormatExpression(reg);
        }
        this.businessOtherDropdown();
        if ((this.businessType.value === "Private_Company") || (this.businessType.value === "Close_Corporation")) {
            var field = this.form.querySelector("input.form__input--identification");
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var labelItem = formGroupItem.querySelector('label');
                labelItem.innerText = "Business Registration Number";
                var newBusRegField = document.createElement('input');
                newBusRegField.setAttribute("name", "business-reg-number");
                newBusRegField.classList.add("form__input");
                newBusRegField.classList.add("form__input--required");
                newBusRegField.classList.add("form__input--busReg");
                newBusRegField.classList.add("form__input--business-registration");
                newBusRegField.placeholder = "Enter your business registration number";
                // This adds slashes to the business registration number
                newBusRegField.addEventListener("input", deleteContent);
                newBusRegField.addEventListener("blur", addBlur);
                newBusRegField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newBusRegField, field);
            }
        }
        else {
            // This removes event listener
            var field = this.form.querySelector("input.form__input--business-registration");
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var labelItem = formGroupItem.querySelector('label');
                labelItem.innerText = "ID Number";
                var newIdField = document.createElement('input');
                newIdField.setAttribute("name", "id-number");
                newIdField.setAttribute("maxlength", "13");
                newIdField.classList.add("form__input");
                newIdField.classList.add("form__input--required");
                newIdField.classList.add("form__input--identification");
                newIdField.placeholder = "Enter your South African ID number";
                newIdField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newIdField, field);
            }
        }
    };
    FormItemBusinessGrowYourMoney.prototype.businessOtherDropdown = function () {
        var field = this.businessType;
        var formGroup = field.closest(".form__group");
        var formGroups = Array.from(this.element.querySelectorAll(".form__group"));
        //const formNote: any = this.element.querySelector(`.apply-now__note`);
        //const formButtons: any = this.element.querySelector(`.apply-now__buttons`);
        var formOtherContainer = this.element.querySelector(".form__business-other--container");
        if (this.businessType.value === "OtherContent") {
            //formGroups.map((item: any) => {
            //	item.classList.add(`form__group--hidden`);
            //});
            //formNote.classList.add(`hidden`);
            //formButtons.classList.add(`hidden`);
            //formOtherContainer.classList.add(`active`);
            this.showDisplayView("other");
        }
        else {
            //formGroups.map((item: any) => {
            //	item.classList.remove(`form__group--hidden`);
            //});
            //formNote.classList.remove(`hidden`);
            //formButtons.classList.remove(`hidden`);
            //formOtherContainer.classList.remove(`active`);
            this.showDisplayView("display");
        }
        formGroup.classList.remove("form__group--hidden");
    };
    FormItemBusinessGrowYourMoney.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
            window.location.href = this.closeButton.getAttribute('data-url');
        }
        else {
            window.location.href = this.doneSubmit.getAttribute('data-url');
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
    };
    FormItemBusinessGrowYourMoney.prototype.submitForm = function (form) {
        var _this = this;
        // variables
        var description = form.querySelector("input[name=description]");
        var firstname = form.querySelector("input[name=first-name]");
        var lastname = form.querySelector("input[name=last-name]");
        var businessType = form.querySelector("select[name=business-type]");
        var businessName = form.querySelector("input[name=business-name]");
        var phoneNumber = form.querySelector("input[name=phone-number]");
        var altPhoneNumber = form.querySelector("input[name=alternative-number]");
        var emailAddress = form.querySelector("input[name=email-address]");
        var businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var idnumber = form.querySelector("input[name=id-number]");
        var existingCustomer = form.querySelector("input[name=existing-customer]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var recipient = form.querySelector('input[name=recipient]');
        var _postData = {
            'recipient': (recipient ? recipient.value : ''),
            'description': (description ? description.value : ""),
            'businessDescription': (description ? description.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'firstname': (firstname ? firstname.value : ""),
            'surname': (lastname ? lastname.value : ""),
            'businessType': (businessType ? businessType.value.replace(/_/g, " ") : ""),
            'businessName': (businessName ? businessName.value : ""),
            'contactNo': (phoneNumber ? phoneNumber.value : ""),
            'AltContactNo': (altPhoneNumber ? altPhoneNumber.value : ""),
            'email': (emailAddress ? emailAddress.value : ""),
            'businessRegNumber': (businessRegNumber ? businessRegNumber.value : ""),
            'idNumber': (idnumber ? idnumber.value : ""),
            'isExistingCustomer': ((existingCustomer ? (existingCustomer.checked ? "YES" : "NO") : "")),
            'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'source': this.formsService.isMobile(),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders')
        };
        this.showDisplayView("loader");
        // service
        var url = this.baseUrl + '/services/SubmitApplicationFormBizBankV1.jsp';
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
            if (pResponse.data && pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url);
                _this.showDisplayView("error");
            }
            else {
                _this.dtmVirtualPage('thank you');
                _this.analyticsService.dtmFormComplete("complete", pResponse.data);
                _this.showDisplayView("success");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessGrowYourMoney.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemBusinessGrowYourMoney.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayOtherContent.classList.add("hidden");
        this.displayIDNumber.classList.add("hidden");
        this.displaybusinessType.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "other":
                this.displayOtherContent.classList.remove("hidden");
                this.displaybusinessType.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                this.displayIDNumber.classList.remove("hidden");
                this.displaybusinessType.classList.remove("hidden");
        }
    };
    FormItemBusinessGrowYourMoney.prototype.dtmVirtualPage = function (pPageNameNew) {
        var urlPath = window.location.pathname;
        var urlSegments = urlPath.split('/');
        var extractedKey = urlSegments[urlSegments.length - 1];
        var pageMapping = {
            '48-hour-notice-deposit': 'business:products and services:grow your money:saving and investment accounts:our accounts:business 48 hour notice deposit success thank you',
            'marketlink-account': 'business:products and services:grow your money:saving and investment accounts:our accounts:business marketlink account success thank you',
            'flexi-advantage-account': 'business:products and services:grow your money:business saving and investment accounts:see all accounts:business flexi advantage success thank you',
            'shariah-call-deposit': "business:products and services:grow your money:business saving and investment accounts:see all accounts:shari'ah business call deposit success thank you",
            'shariah-fixed-deposit': "business:products and services:grow your money:business saving and investment accounts:see all accounts:shari'ah business fixed deposit success thank you",
            'business-solution-accountants': 'business:products and services:business solutions:industry:accounting professional solutions:business solution accountants success thank you',
            'puresave': 'business:products and services:grow your money:business saving and investment accounts:see all accounts:business puresave account  success thank you',
        };
        var taggingValue = pPageNameNew === 'thank you' ?
            pageMapping[extractedKey] : "business:products and services:grow your money:saving and investment accounts:marketlink-account";
        dataLayer.pageName =
            taggingValue;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    return FormItemBusinessGrowYourMoney;
}(Base));
export { FormItemBusinessGrowYourMoney };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-business-grow-your-money/form-item-business-grow-your-money.component.ts
// module id = 1031
// module chunks = 0